import { useCallback, useMemo, useState } from 'react';

const isNotNullish = <T>(value: T): value is NonNullable<T> => {
  if (value === null) return false;
  if (value === undefined) return false;
  return true;
};

export type SortingOptions<TSortProperty, TSortOrder> = {
  sortProperty?: TSortProperty | null;
  sortOrder?: TSortOrder | null;
};

export const useSorting = <TSortProperty, TSortOrder = 'Asc' | 'Desc'>(options?: SortingOptions<TSortProperty, TSortOrder>) => {
  const [sortProperty, setSortProperty] = useState<TSortProperty | null>(options?.sortProperty ?? null);
  const [sortOrder, setSortOrder] = useState<TSortOrder | null>(options?.sortOrder ?? null);

  const updateSortProperty = useCallback((value: TSortProperty | null) => setSortProperty(value), []);
  const updateSortOrder = useCallback((value: TSortOrder | null) => setSortOrder(value), []);

  const clearSorting = useCallback(() => {
    setSortOrder(null);
    setSortProperty(null);
  }, []);

  const hasSorting = useMemo(() => isNotNullish(sortProperty), [sortProperty]);

  return {
    sortProperty,
    sortOrder,
    updateSortProperty,
    updateSortOrder,
    clearSorting,
    hasSorting,
  };
};

export default useSorting;
